var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlbums(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/video-vertical"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video-vertical"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.36 7.78H2V11.25H6.36V7.78Z",
    fill: "#A9B7BB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.36039 6.29V2.13C4.08039 2.55 2.59039 4.02 2.15039 6.28H6.33039C6.34039 6.28 6.35039 6.29 6.36039 6.29Z",
    fill: "#A9B7BB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.36 16.31V12.75H2V16.28H6.24C6.28 16.28 6.32 16.3 6.36 16.31Z",
    fill: "#A9B7BB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.8494 6.28C21.4194 4.09 20.0194 2.65 17.8594 2.18V6.28H21.8494Z",
    fill: "#A9B7BB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.3594 11.25V2.01C16.3094 2 16.2494 2 16.1894 2H7.85938V11.25H16.3594Z",
    fill: "#A9B7BB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M21.9994 12.75H17.8594V16.28H21.9994V12.75Z",
    fill: "#A9B7BB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M17.8594 21.82C19.9994 21.35 21.3994 19.93 21.8394 17.78H17.8594V21.82Z",
    fill: "#A9B7BB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M6.24016 17.78H2.16016C2.62016 20 4.10016 21.45 6.36016 21.87V17.76C6.32016 17.77 6.28016 17.78 6.24016 17.78Z",
    fill: "#A9B7BB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M21.9994 7.78H17.8594V11.25H21.9994V7.78Z",
    fill: "#A9B7BB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M7.85938 12.75V22H16.1894C16.2494 22 16.3094 22 16.3594 21.99V12.75H7.85938Z",
    fill: "#A9B7BB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbums);
export default __webpack_public_path__ + "static/media/albums.9c12aa5003ab52b60170f16291475427.svg";
export { ForwardRef as ReactComponent };